import React from 'react';
import {
  minValue, required,
} from 'react-admin';

import { Grid } from '@mui/material';

import InfoPopover from '../../layout/InfoPopover';
import NumberInput from '../../layout/inputFields/NumberInput';

const KycFormDataMaxAgeInput = () => (
  <Grid size={12}>
    <NumberInput
      validate={[required(), minValue(0)]}
      fullWidth
      source="ruleParameters.kycFormDataMaxAge"
      label="Max KYC form age (days)"
      popups={(
        <InfoPopover
          key="max days"
          title="Max KYC form age"
          content={
            'Set a maximum number of days since the creation of the KYC form. \n If the KYC form data is older than this, it is treated as stale.'
          }
        />
      )}
    />
  </Grid>
);

export default KycFormDataMaxAgeInput;
